export const getNextWeekRange = () => {
  const today = new Date();
  const nextWeekEnd = new Date(today);
  nextWeekEnd.setDate(today.getDate() + 7);
  const nextWeekStart = new Date(today);
  nextWeekStart.setDate(today.getDate() + 1);
  return [nextWeekStart, nextWeekEnd];
};
